var IDX = 36, HEX = '';
while (IDX--)
    HEX += IDX.toString(36);
export function uid(len) {
    var str = '', num = len || 11;
    while (num--)
        str += HEX[(Math.random() * 36) | 0];
    return str;
}
//# sourceMappingURL=uid.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/shared/esm/uid.js
// module id = null
// module chunks = 